import React, {Component} from 'react';
import {connect} from "react-redux";
import FJToolbarCommon from '../view/FJToolbarCommon';
import FJZoomScale from '../view/FJZoomScale';
import classNames from "classnames";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import FJTransform from "../view/FJTransform";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJToolbarButton from "../view/FJToolbarButton";
import FJResourceAction from "../../../redux/action/FJResource.action";
import FJTransparency from "../view/FJTransparency";
import FJToolbarFilterContainer from "./FJToolbarFilterContainer";
import FJCropIcon from '../../../icon/crop.svg'
import InlineSVG from "react-inlinesvg";
import FJToolbarIconButton from "../view/FJToolbarIconButton";

class FJToolbarPhotoContainer extends Component {

  toggleResourcePanel = (type) => {
    let {showType, lastType, updateShowType} = this.props;
    if (showType === type) {
      updateShowType(lastType);
    } else {
      updateShowType(type);
    }
  };

  togglePhotoAnimationPanel = () => {
    this.toggleResourcePanel(FJViewConstant.RESOURCES_PHOTO_TRANSITION);
  }

  render() {
    let {
      zoomScale,
      zoomDataChange,
      adaptClick,
      mediaStatus,
      showType,
      opacityValue,
      opacityChange,
      onLinkFun,
      onRetryFun,
      couldMask,
      handleCrop,
      mediaName
    } = this.props;
    let containerClass = classNames('c-toolbar-video', {active: this.props.active});
    let mediaSuccess = mediaStatus === FJViewConstant.MEDIA_STATUS_SUCCESS;
    return (
      <FJToolbarCommon className={containerClass}
                       mediaStatus={mediaStatus}
                       mediaName={mediaName}
                       onLinkFun={onLinkFun}
                       onRetryFun={onRetryFun}
      >
        <FJZoomScale zoomScale={zoomScale}
                     disabled={!mediaSuccess}
                     zoomDataChange={zoomDataChange}
                     style={{marginRight: 6}}
                     adaptClick={adaptClick}/>
        <FJToolbarDevider/>
        <FJTransform type='media'
                     disabled={!mediaSuccess}
        />
        <FJToolbarIconButton icon={<InlineSVG src={FJCropIcon} />}
                             style={{float: 'left', marginLeft: '6px'}}
                             onClick={handleCrop}
                             disabled={!mediaSuccess || !couldMask}
                             className='u-tooltip-bottom c-toolbar-icon-btn float-left'
                             tooltip={FJLocalStore._('crop') }
        />
        <FJToolbarDevider/>
        <FJToolbarFilterContainer mediaSuccess={mediaSuccess}/>
        <FJToolbarDevider/>
        <FJToolbarButton text={FJLocalStore._('animation')}
                         style={{float: 'left'}}
                         onClick={this.togglePhotoAnimationPanel}
                         active={showType === FJViewConstant.RESOURCES_PHOTO_TRANSITION}
                         disabled={!mediaSuccess}
        />
        <FJToolbarDevider/>
        <FJTransparency opacityValue={opacityValue}
                        opacityChange={opacityChange}
                        disabled={!mediaSuccess}
        />
      </FJToolbarCommon>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    zoomScale: state.toolbarPhoto.zoomScale,
    mediaStatus: state.toolbarPhoto.mediaStatus,
    mediaName: state.toolbarPhoto.mediaName,
    isEditMode: state.toolbar.isEditMode,
    couldMask: state.toolbar.couldMask,
    isShowEditMode: state.toolbar.isShowEditMode,
    showType: state.resource.showType,
    lastType: state.resource.lastType,
    opacityValue: state.toolbar.opacityValue
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    zoomDataChange: function (type, value) {
      dispatch(FJToolbarAction.photoZoomDataChangeAction(type, value));
    },
    adaptClick: function (type) {
      dispatch(FJToolbarAction.photoAdaptiveChangeAction(type));
    },
    toggleEditMode: function () {
      dispatch(FJToolbarAction.toggleEditorModeAction());
    },
    updateShowType: function (type) {
      dispatch(FJResourceAction.setShowTypeAction(type, undefined, true));
    },
    opacityChange: function (type, value) {
      dispatch(FJToolbarAction.changeOpacityValueAction(type, value))
    },
    handleCrop: function () {
      dispatch(FJToolbarAction.setCropAction(true));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarPhotoContainer);
